import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetMostRecentAdrId } from '@rsos/components/capstone/DataCards/adrDataSlice';
import {
  hasNotificationPermission,
  pushNotification,
} from '@rsos/components/capstone/PushNotifications/PushNotifications';
import { callQueueSelector } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import checkAniAliAccessSelector from '@rsos/utils/checkAniAliAccessSelector';
import useIsIRP from '@rsos/utils/useIsIRP';
import { _911INFORM, _911_INFORM } from '../../constants/spatialLayers';

const use911informNotification = onClickNotification => {
  const dispatch = useDispatch();
  const { irpVersion } = useIsIRP();

  const [mostRecentCallerId, setMostRecentCallerId] = useState(null);
  const mostRecentAdrId = useSelector(state => state.adrData.mostRecentAdrId);

  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );
  const hasAniAliAccess = useSelector(state =>
    checkAniAliAccessSelector({ psaps: state.psaps, sinatra: state.sinatra }),
  );

  const filteredCalls = useSelector(state =>
    callQueueSelector(state.emergencyCalls.callQueue, hasAniAliAccess),
  );

  const mostRecentCall = filteredCalls[mostRecentCallerId] || {};

  useEffect(() => {
    if (mostRecentAdrId && mostRecentAdrId.includes('tel://')) {
      const callerId = mostRecentAdrId.split('tel://')[1];
      // Do not update state if selectedCallerID === callerId to prevent
      // a push notification on page refresh
      if (selectedCallerID !== callerId) {
        setMostRecentCallerId(callerId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mostRecentAdrId]);

  useEffect(() => {
    // If `mostRecentAdrId` is for a call, check if it has 911inform data and
    // send a push notification if there is only 1 location for the call
    if (Object.keys(mostRecentCall).length) {
      const hasOneLocation = mostRecentCall.core.locations.length === 1;
      // numberWithNewLocation does not contain SAData when first updated in the state as a new hermes message has not come in with it

      // Send push notification if new number contains 911inform data and is the
      // has one location for the call.
      if (
        hasNotificationPermission(irpVersion) &&
        hasOneLocation &&
        !!mostRecentCall.additionalData?.[_911_INFORM]
      ) {
        pushNotification({
          title: 'New Event within Connected Building from RapidSOS',
          callback: () => {
            onClickNotification({
              handler: _911INFORM,
              callerId: mostRecentCallerId,
            });
          },
        }).then(() => {
          dispatch(resetMostRecentAdrId());
          // notification has been sent. reset mostRecentCallerId to prevent
          // pushing another
          setMostRecentCallerId(null);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mostRecentCall]);

  return null;
};

export default use911informNotification;
